import {
  SET_SELECTED_STATUS_ACTION,
  SET_SEARCH_TEXT_ACTION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  RESET_PAGINATION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from './actions.type';

import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_CURRENT_PAGE,
  SET_OFFSET,
  SET_FILTER,
  SET_LIST_OPTIONS,
  SET_CURRENT_SESSION_STATE,
  INIT_STATE,
} from './mutations.type';


export default {
  [SET_SELECTED_STATUS_ACTION](context, status) {
    context.commit(SET_SELECTED_STATUS, status);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [RESET_PAGINATION](context) {
    context.commit(SET_CURRENT_PAGE, 1);
    context.commit(SET_OFFSET, 0);
  },
  [SET_FILTER_ACTION](context, filter) {
    context.commit(SET_FILTER, filter);
  },
  [SET_LIST_OPTIONS_ACTION](context, listOptions) {
    context.commit(SET_LIST_OPTIONS, listOptions);
  },
  [SET_CURRENT_SESSION_STATE_ACTION](context, ids) {
    context.commit(SET_CURRENT_SESSION_STATE, ids);
  },
  [INIT_STATE_ACTION](context, ids) {
    context.commit(INIT_STATE, ids);
  },
};
